module.exports = __webpack_public_path__ + "img/bar_chat.22c8265c.svg";